"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip/js/Tooltip"));

var _CloudDisconnected = _interopRequireDefault(require("@react/react-spectrum/Icon/CloudDisconnected"));

var _Cloud = _interopRequireDefault(require("@react/react-spectrum/Icon/Cloud"));

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

/**
 * NetworkIndicator component for display offline vs online state icon
 * @returns {ReactElement} markup
 */
var NetworkIndicator = function NetworkIndicator(_ref) {
  var isOffline = _ref.isOffline,
      tooltipDirection = _ref.tooltipDirection;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var icon;
  var tooltipTextId;

  if (isOffline) {
    icon = /*#__PURE__*/_react.default.createElement(_CloudDisconnected.default, null);
    tooltipTextId = 'comments.network.status.offline';
  } else {
    icon = /*#__PURE__*/_react.default.createElement(_Cloud.default, null);
    tooltipTextId = 'comments.network.status.online';
  }

  var tooltipText = formatMessage({
    id: tooltipTextId
  });
  var networkIndicatorText = formatMessage({
    id: 'comments.arialabel.button.networkIndicator'
  });
  var networkStatusText = formatMessage({
    id: "comments.network.status.".concat(isOffline ? 'offline' : 'online')
  });
  return /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    placement: tooltipDirection === 'right' ? 'right' : 'left',
    style: {
      pointerEvents: 'none'
    },
    trigger: "hover"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-disabled": true,
    "aria-label": "".concat(networkIndicatorText, " ").concat(networkStatusText),
    "data-test": "network-icon",
    icon: icon,
    variant: "tool"
  }), /*#__PURE__*/_react.default.createElement(_Tooltip.default, null, tooltipText));
};

NetworkIndicator.defaultProps = {
  isOffline: false,
  tooltipDirection: 'right'
};
NetworkIndicator.propTypes = {
  isOffline: _propTypes.default.bool,
  tooltipDirection: _propTypes.default.oneOf(['right', 'left'])
};
var _default = NetworkIndicator;
exports.default = _default;